import React from 'react';
import ReUsableBanner from '../../../../components/common/ReUsableBanner';

const GalleryBanner = () => {
	const asideImage = '/assets/gallery-banner.png';
	const smallTitle = 'Gallery';
	const headerContent = 'Savor the Moments with Our Catering!';
	const paraContent = `Let our pictures speak for our quality and passion for food. Get inspired and make your next event truly special with our catering services! Let our pictures speak for our quality and passion for food. Get inspired and make your next event truly special with our catering services!`;

	return (
		<div>
			<ReUsableBanner
				asideImage={asideImage}
				smallTitle={smallTitle}
				headerContent={headerContent}
				paraContent={paraContent}
			/>
		</div>
	);
};

export default GalleryBanner;
